// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__UrLdU","spacer":"loading-dots_spacer___D5Yx","blink":"loading-dots_blink__fzdj0"};